export default __webpack_public_path__ + "static/media/2.65556a88.jpeg";